import Katex from 'katex'

// 返回公式转化对象
export default Katex